import React from "react";

const ImageBlock = ({ block }) => {
    if (!block.url && !block.src) {
        return null;
    }

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                margin: "20px 0",
            }}
        >
            <img
                src={block.url || block.src}
                alt={block.alt || ""}
                style={{
                    maxWidth: "100%",
                    height: "auto",
                }}
            />
        </div>
    );
};

export default ImageBlock;